import { type YDatabase } from '@databases/collab/y-database';
import { err, ok, type Result } from 'neverthrow';

import { type SdkError } from '../../types.ts';

export function assertViewNotExists(
  ydb: YDatabase,
  viewId: string
): Result<void, SdkError> {
  if (ydb.viewsById[viewId]) {
    return err({
      type: 'STATE_ERROR',
      reason: 'VIEW_ALREADY_EXISTS',
      message: `View '${viewId}' already exists`
    });
  }

  return ok(undefined);
}
